/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Trial_Days_LabelInputs */

const en_admin_invite_codes_trial_days_label = /** @type {(inputs: Admin_Invite_Codes_Trial_Days_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial days`)
};

const zh_admin_invite_codes_trial_days_label = /** @type {(inputs: Admin_Invite_Codes_Trial_Days_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用天数`)
};

/**
* | output |
* | --- |
* | "Trial days" |
*
* @param {Admin_Invite_Codes_Trial_Days_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_trial_days_label = /** @type {((inputs?: Admin_Invite_Codes_Trial_Days_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Trial_Days_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_trial_days_label(inputs)
	return zh_admin_invite_codes_trial_days_label(inputs)
});
export { admin_invite_codes_trial_days_label as "admin.invite_codes.trial_days_label" }